import { host, headers } from 'shared/constants'
import { hostApiMirror } from '../shared/constants'

const parseJSON = response => {
  if (response.status !== 204) return response.json()
  else return true
}

const checkStatus = response => {
  if (response.status >= 200 && response.status < 300) {
    return response
  } else {
    var error = new Error(response.statusText)
    error.response = response
    throw error
  }
}

const getHeaders = token => {
  if (token) {
    return {
      ...headers,
      Authorization: `Bearer ${token}`
    }
  } else {
    return headers
  }
}

const getHeadersWithApiKey = apikey => {
  if (apikey) {
    return {
      ...headers,
      apikey: `${apikey}`
    }
  } else {
    return headers
  }
}

const getHeadersWithApiKeyAndToken = (apikey, token) => {
  if (apikey && token) {
    return {
      ...headers,
      apikey: `${apikey}`,
      Authorization: `Bearer ${token}`
    }
  } else {
    return headers
  }
}

const getHeadersWithXApiKey = apikey => {
  if (apikey) {
    return {
      ...headers,
      'X-api-key': `${apikey}`
    }
  } else {
    return headers
  }
}

const postWithApiKey = (h, apikey, data) => {
  console.log(' [API CALL] POST WITH APIKEY ', h, apikey, data)
  if (!data) console.log('[WARNING] POST CALL WITH NO DATA', data)
  return (window.fetch(h, {
    body: data ? JSON.stringify(data) : '',
    method: 'POST',
    headers: getHeadersWithApiKey(apikey)
  })
    .then(checkStatus)
    .then(parseJSON))
}

const postWithApiKeyAndToken = (h, apikey, token, data) => {
  console.log(' [API CALL] POST WITH APIKEY ', h, apikey, data)
  if (!data) console.log('[WARNING] POST CALL WITH NO DATA', data)
  return (window.fetch(h, {
    body: data ? JSON.stringify(data) : '',
    method: 'POST',
    headers: getHeadersWithApiKeyAndToken(apikey, token)
  })
    .then(checkStatus)
    .then(parseJSON))
}

const postWithXApiKey = (h, apikey, data) => {
  if (!data) console.log('[WARNING] POST CALL WITH NO DATA', data)
  return (window.fetch(h, {
    body: data ? JSON.stringify(data) : '',
    method: 'POST',
    headers: getHeadersWithXApiKey(apikey)
  })
    .then(checkStatus)
    .then(parseJSON))
}

// PATCH=https://wideeyes.atlassian.net/wiki/spaces/DEV/pages/616759331/WID-823+Imposible+to+change+category+in+annotation+platform
const putWithApiKey = (h, apikey, data) => {
  console.log(' [API CALL] PUT WITH APIKEY ', h, apikey, data)
  if (!data) console.log('[WARNING] PUT CALL WITH NO DATA', data)
  return (window.fetch(h, {
    body: data ? JSON.stringify(data) : '',
    method: 'PUT',
    headers: getHeadersWithApiKey(apikey)
  })
    .then(checkStatus)
    .then(parseJSON))
}

const putWithApiKeyAndToken = (h, apikey, token, data) => {
  console.log(' [API CALL] PUT WITH APIKEY AND TOKEN', h, apikey, data)
  if (!data) console.log('[WARNING] PUT CALL WITH NO DATA', data)
  console.log(JSON.stringify(data))
  console.log(getHeadersWithApiKeyAndToken(apikey, token))
  return (window.fetch(h, {
    body: data ? JSON.stringify(data) : '',
    method: 'PUT',
    headers: getHeadersWithApiKeyAndToken(apikey, token)
  })
    .then(checkStatus)
    .then(parseJSON))
}

const post = (h, token, data) => {
  console.log(' [API CALL] POST ', h, token, data)
  if (!data) console.log('[WARNING] POST CALL WITH NO DATA', data)
  return (window.fetch(h, {
    body: data ? JSON.stringify(data) : '',
    method: 'POST',
    headers: getHeaders(token)
  })
    .then(checkStatus)
    .then(parseJSON))
}

const put = (h, token, data) => {
  console.log(' [API CALL] PUT ', h, token, data)
  if (!data) console.log('[WARNING] PUT CALL WITH NO DATA', data)
  return (window.fetch(h, {
    body: JSON.stringify(data),
    method: 'PUT',
    headers: getHeaders(token)
  })
    .then(checkStatus)
    .then(parseJSON))
}

const postWithoutHeader = (h, data, params) => {
  console.log(' [API CALL] POST WITHOUT HEADER ', h, data)
  if (!data) console.log('[WARNING] POST CALL WITH NO DATA', data)
  if (params) {
    // we only add test par
    if (params.env === 'test') {
      h = h + '?' + params.env + '=true'
    }
  }

  return (window.fetch(h, {
    body: JSON.stringify(data),
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }

  })
    .then(checkStatus)
    .then(parseJSON))
}

const convertToHeaders = (query) => {
  return query ? '?' + Object.keys(query)
    .map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(query[key]))
    .join('&')
    .replace(/%20/g, '+') : ''
}

const get = (h, token, params) => {
  console.log('[API CALL] GET ', h, token, params)
  return (
    window.fetch(h + convertToHeaders(params), {
      method: 'GET',
      headers: getHeaders(token)
    })
    .then(checkStatus)
    .then(parseJSON)
  )
}

const getWithApikeyAndConvertHeaders = (h, apikey, params) => {
  console.log('[API CALL] GET WITH APIKEY', h, apikey, params)
  return (
    window.fetch(h + convertToHeaders(params), {
      method: 'GET',
      headers: getHeadersWithApiKey(apikey)
    })
    .then(checkStatus)
    .then(parseJSON)
  )
}

const getWithApikey = (h, apikey, params) => {
  console.log('[API CALL] GET WITH APIKEY', h, apikey, params)
  return (
    window.fetch(h, {
      method: 'GET',
      headers: getHeadersWithApiKey(apikey)
    })
    .then(checkStatus)
    .then(parseJSON)
  )
}

const getWithApikeyAndToken = (h, apikey, token, params) => {
  console.log('[API CALL] GET WITH APIKEY AND TOKEN', h, apikey, token, params)
  return (
    window.fetch(h + convertToHeaders(params), {
      method: 'GET',
      headers: getHeadersWithApiKeyAndToken(apikey, token)
    })
    .then(checkStatus)
    .then(parseJSON)
  )
}

const del = (h, token) => {
  console.log('[API CALL] DELETE', h, token)
  return (
    window.fetch(h, {
      method: 'DELETE',
      headers: getHeaders(token)
    })
    .then(checkStatus)
    .then(parseJSON)
  )
}

// category
export const getCategories = (apikey, token) => postWithApiKeyAndToken(`${host}/v2/get_category_data`, apikey, token)
export const changeCategory = (apikey, token, params, data) => putWithApiKeyAndToken(`${host}/v2/product/${params.uid}/changeCategory`, apikey, token, data)

// products
export const getProducts = (apikey, token, params, data) => getWithApikeyAndToken(`${host}/v2/product`, apikey, token, params)
export const searchProduct = (apikey, token, params, data) => getWithApikeyAndToken(`${host}/v2/product/${params.uid}`, apikey, token, data)
export const detect = (token, data) => post(`${host}/v4/DetectAndFeatures`, token, data)
export const recognize = (token, data) => postWithApiKey(`${host}/v1/Recognize`, token, data)
export const searchById = (apikey, data) => postWithApiKey(`${host}/v4/SearchById`, apikey, data)
export const searchByImage = (token, data) => post(`${host}/v4/SearchByImage`, token, data)
export const searchByImageWithApiKey = (apikey, data) => postWithApiKey(`${host}/v4/SearchByImage`, apikey, data)
export const toValidate = (token, data) => get(`${host}/annotator/v2/job/${data.jobId}/image/toValidate`, token, data)
export const getJobs = (token, data) => get(`${host}/annotator/v2/job`, token, {...data, limit: 300, page: 1})
export const getAnnotations = (token, data) => get(`${host}/annotator/v2/job/${data.jobId}/image/${data.image.id}/annotation`, token, data)
export const saveDetection = (token, params, data) => post(`${host}/annotator/v2/job/${params.jobId}/image/${params.imageId}/annotation/${params.annotationId}`, token, data)

// looks
export const getLook = (apikey, token, data) => getWithApikeyAndToken(`${host}/v2/look/uid/${data.uid}`, apikey, token, data)
export const getLookProducts = (apikey, token, uid) => getWithApikeyAndToken(`${host}/v2/product/${uid}`, apikey, token)
export const getLookProductsInactive = (apikey, token, uid) => getWithApikeyAndToken(`${host}/v2/product/${uid}?status=inactive`, apikey, token)

// Style advisor
export const getAnnotationFromStyleAdvisor = (token, data) => postWithApiKey(`${hostApiMirror}/v5/styleAdvisor`, token, data)

// Twinned looks (Hermanados)
export const getTwinnedLooks = (apikey, params) => getWithApikey(`${host}/look/twinned/${params.uid}`, apikey, params)

// Text Search
export const getTextSearchProducts = (apikey, data) => postWithApiKey(`${hostApiMirror}/v5/textSearch`, apikey, data)

export const toNextJob = (token, params, data) => post(`${host}/annotator/v2/job/${params.jobId}/image/${params.imageId}/toNextJob`, token, data)
export const toLastJob = (token, params, data) => post(`${host}/annotator/v2/job/${params.jobId}/image/${params.imageId}/toLastJob`, token, data)

export const updateImage = (token, params, data) => post(`${host}/annotator/v2/job/${params.jobId}/image/${params.imageId}`, token, data)
export const deleteImage = (token, params, data) => del(`${host}/annotator/v2/job/${params.jobId}/image/${params.imageId}`, token, data)
// make delete call to http://api.wide-eyes.it/annotator/v2/job/12/image/21425/annotation/121264
// make post call to Request URL:http://api.wide-eyes.it/annotator/v2/job/12/image/21425/annotation?mode=supervisor
// with {"data":"{\"bbox\":[{\"tag\":\"scarf\",\"x1\":150,\"y1\":55,\"x2\":272,\"y2\":348},{\"tag\":\"boots\",\"x1\":143,\"y1\":362,\"x2\":218,\"y2\":580},{\"tag\":\"boots\",\"x1\":240,\"y1\":357,\"x2\":306,\"y2\":578}]}"}

// Mocks
// export const searchProduct = (token, params, data) => searchProductMock(`${host}/product/${params.uid}`, token, data)

// export const getAnnotations = (token, data) => getAnnotationsMock(`${host}/annotator/v2/job/${data.jobId}/image/${data.imageId}/annotation`, token, data)
// export const saveDetection = (token, data) => saveDetectionMock(`${host}/annotator/v2/job/${data.jobId}/image/${data.imageId}/annotation`, token, data)
// export const toValidate = (token, data) => toValidateMock(`${host}/annotator/v2/job/${data.jobId}/image/toValidate`, token, data)
// export const searchByImage = (token, data) => searchByImageMock(`${host}/v4/SearchByImage`, token, data)
// export const recognize = (token, data) => recognizeMock(`${host}/v1/Recognize`, token, data)
// export const removeDetection = (token, data) => saveDetectionMock(`${host}/annotator/v2/job/${data.jobId}/image/${data.imageId}/annotation`, token, data)

// users
export const login = data => post(`${host}/login`, null, data)
export const getUser = token => get(`${host}/users/show`, token)
export const getCompanyUser = apikey => getWithApikeyAndConvertHeaders(`${host}/users/show`, apikey)
export const fireEvent = (apikey, data) => postWithApiKey(`${host}/events/fire`, apikey, data)




// WEBPACK FOOTER //
// ./src/utils/api.js